// utility to parse a date string in various formats
export function parseScheduleDateLocal(input) {
    // "YYYY-MM-DD" → local date (no timezone conversion)
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(input));
    if (m) {
      const [, y, mo, d] = m;
      return { date: new Date(Number(y), Number(mo) - 1, Number(d)), isDateOnly: true };
    }
    // Fallback: parse normally
    const s = String(input);
    return { date: new Date(s), isDateOnly: !s.includes('T') };
  }
  
  export function formatLocalDate(d) {
    return d.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC', // Force UTC to prevent time zone shifts
      });
}
  
  // handy: set local hour/min/sec on a Date (keeps it local)
  export function withLocalTime(baseDate, h = 7, m = 0, s = 0) {
    const d = new Date(baseDate);
    d.setHours(h, m, s, 0);
    return d;
  }
  